module.exports = __webpack_public_path__ + "img/electric_no_zone_selected.afc7ab42.svg";